import { useCustomT } from '@flowwai-frontend/shared/common-components'
import { useFailureToastWithRefresh } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { OpenSearchPipelineItemsQuery as Query } from './query.generatedTypes'
import { SearchResultType } from '../../types'

const useAPIResponseHandler = (data?: Query) => {
   let searchResults: SearchResultType[] = []
   let totalCount: number | null = null

   const { showFailureToastWithRefresh } = useFailureToastWithRefresh()
   const t = useCustomT('globalSearch:searchModal')

   if (!data)
      return {
         searchResults: searchResults,
         totalCount
      }

   const searchResultsData = data.openSearchPipelineItems

   const onClickRefresh = (): void => {
      window.location.reload()
   }

   switch (searchResultsData.__typename) {
      case 'OpenSearchPipelineItemsResult': {
         totalCount = searchResultsData.totalCount
         searchResults = searchResultsData.pipelineItems.map(pipelineItem => ({
            pipelineItemId: pipelineItem.pipelineItemId,
            name: pipelineItem.name ?? '--',
            stage: pipelineItem.stage || undefined
         }))
         break
      }
      case 'PipelineAccessDenied': {
         const title = t('pipelineAccessDenied.title')
         const message = t('pipelineAccessDenied.description')
         showFailureToastWithRefresh(title, message, onClickRefresh)
         break
      }
      default: {
         const errorMessage = getErrorMessageFromErrorType(
            searchResultsData.__typename
         )
         showFailureToastWithRefresh(errorMessage, '', onClickRefresh)
      }
   }

   return {
      searchResults,
      totalCount
   }
}

export default useAPIResponseHandler
